import ajax from '../../common/services/httpService';

export { getDashboardLayout, saveDashboardLayout };

/**
 * Load the logged-in user's saved layout for a dashboard.
 * @param {String} dashboardKey e.g. 'overview'
 * @returns {Promise<Array | null>} saved layout items, or null when the user never saved one
 */
async function getDashboardLayout(dashboardKey) {
    const response = await ajax.get(`user/dashboard-layout/${dashboardKey}`, null, null, { silent: true });
    return response && response.layout ? response.layout : null;
}

/**
 * Persist the user's layout for a dashboard.
 * @param {String} dashboardKey e.g. 'overview'
 * @param {Array<{ i: String; x: Number; y: Number; w: Number; h: Number; widgetType: String; config: Object; }>} layout
 * @returns {Promise<Array>} the saved layout as returned by the backend
 */
async function saveDashboardLayout(dashboardKey, layout) {
    const response = await ajax.put(`user/dashboard-layout/${dashboardKey}`, { layout });
    return response && response.layout ? response.layout : layout;
}
